import { render } from "./IconProvider.vue?vue&type=template&id=0629bdf3"
import script from "./IconProvider.vue?vue&type=script&lang=js"
export * from "./IconProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__